module.exports = __webpack_public_path__ + "img/样例3.9c08914c.png";